module.exports = __webpack_public_path__ + "img/compass1.952b085a.png";